import querystring from 'querystring';

export const getQueryParams = location => querystring.parse(location.search.substring(1, location.search.length));
